//Analytics for both Interactive Hotspot and Enhanced Hotspot
analytics.eventConfig.push({
    "target": ".hotspot_content",
    "codeId": "hs01",
    "events": [
        {
            "eventTarget": ".hotspot__item",
            "eventType": "click",
            "tags": {
                "componentId": "hs01",
                "componentName": "hotspots",
                "elementText": "",
                "elementType": "hotspots click",
                "event": "navigation",
                "eventType": "hotspots navigation click",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
    ]
},
{
    "target": ".hotspot__aside",
    "codeId": "hs01",
    "events": [
        {
            "eventTarget": ".hotspot__aside__item",
            "eventType": "click",
            "tags": {
                "componentId": "hs01",
                "componentName": "hotspots",
                "elementText": "",
                "elementType": "hotspots click",
                "event": "navigation",
                "eventType": "hotspots sidebar navigation click",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
        {
            "eventTarget": ".hotspot__aside__item",
            "eventType": "HotspotSideNav",
            "tags": {
                "componentId": "hs01",
                "componentName": "hotspots",
                "elementText": "",
                "elementType": "hotspots click",
                "event": "navigation",
                "eventType": "hotspots sidebar navigation click",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
    ]
},
{
    "target": ".hotspot__main",
    "codeId": "hs02",
    "events": [
        {
            "eventTarget": "a[href]:not(.hotspot__button)",
            "eventType": "click",
            "tags": {
                "componentId": "hs02",
                "componentName": "hotspots link",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "hotspots link click",
                "event": "navigation",
                "eventType": "hotspots product link click",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
    ]
},
{
    "target": ".hotspot__main",
    "codeId": "hs03",
    "events": [
        {
            "eventTarget": ".hotspot__button",
            "eventType": "click",
            "tags": {
                "componentId": "hs03",
                "componentName": "hotspots button",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "hotspots button click",
                "event": "navigation",
                "eventType": "hotspots product button click",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
    ]
},
{
    "target": ".hotspot__content", 
    "codeId": "hs04",
    "events": [
        {
            "eventTarget": ".hotspot__content__close",
            "eventType": "click",
            "tags": {
                "componentId": "hs04",
                "componentName": "hotspots close",
                "elementText": "",
                "elementType": "hotspots click",
                "event": "navigation",
                "eventType": "hotspots closed",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
        {
            "eventTarget": ".hotspot__content__close",
            "eventType": "HotspotCloseButton",
            "tags": {
                "componentId": "hs04",
                "componentName": "hotspots close",
                "elementText": "",
                "elementType": "hotspots click",
                "event": "navigation",
                "eventType": "hotspots closed",
                "parentListSource": "",
                "parentName": "",
                "parentTitle": "",
            }
        },
    ]
});